import React from 'react';
import { Link } from 'react-router-dom';
import { useDarkMode } from '../../context/DarkModeContext';
import { RefreshCwIcon, ThumbsUpIcon, StarIcon } from 'lucide-react';
const Recommendations = () => {
  const {
    darkMode
  } = useDarkMode();
  const sections = [{
    title: "Because you read 'The Silent Echo'",
    books: [{
      id: 1,
      title: 'Midnight Shadows',
      author: 'Sarah Johnson',
      cover: 'https://images.unsplash.com/photo-1515876305430-f06edab8282a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=800'
    }, {
      id: 2,
      title: 'Whispers in the Dark',
      author: 'Sarah Johnson',
      cover: 'https://images.unsplash.com/photo-1598646506899-ac6be1060f4b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=800'
    }, {
      id: 3,
      title: 'Broken Echoes',
      author: 'Elena Richards',
      cover: 'https://images.unsplash.com/photo-1589998059171-988d887df646?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=800'
    }]
  }, {
    title: 'Trending in Fantasy Romance',
    books: [{
      id: 4,
      title: 'Heart of the Storm',
      author: 'Marcus Chen',
      cover: 'https://images.unsplash.com/photo-1516979187457-637abb4f9353?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=800'
    }, {
      id: 5,
      title: 'Soul of Fire',
      author: 'Marcus Chen',
      cover: 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=800'
    }]
  }];
  return <div className={`min-h-screen ${darkMode ? 'bg-gray-900 text-gray-100' : 'bg-gray-50 text-gray-900'} py-8`} data-id="element-12348" data-mp="1whalvkkidyjs">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-12349" data-mp="z0byqglgldb1">
        <div className="flex justify-between items-center mb-8" data-id="element-12350" data-mp="1406m4a60zkrc">
          <div data-id="element-12351" data-mp="13yn34bszivlv">
            <h1 className="text-3xl font-bold" data-id="element-12352" data-mp="13y3nx2upylbj">For You</h1>
            <p className={`mt-1 ${darkMode ? 'text-gray-400' : 'text-gray-600'}`} data-id="element-12353" data-mp="27a2lk2n00w4b">
              Personalized recommendations based on your reading history
            </p>
          </div>
          <button className="flex items-center px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors" data-id="element-12354" data-mp="2g2w4qb5kgfng">
            <RefreshCwIcon className="h-4 w-4 mr-2" data-id="element-12355" data-mp="1obzt1dv8sh1r" />
            Refresh
          </button>
        </div>

        <div className="space-y-12" data-id="element-12356" data-mp="1je6o0o5odt32">
          {sections.map((section, idx) => <section key={idx} data-id="element-12357" data-mp="1xcxvhrq18gi8" data-mpi={idx}>
              <h2 className="text-xl font-bold mb-4 flex items-center" data-id="element-12358" data-mp="1xdzb89hztr6a">
                <StarIcon className="h-5 w-5 text-yellow-500 mr-2 fill-current" data-id="element-12359" data-mp="1sdlc5gyddrke" />
                {section.title}
              </h2>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6" data-id="element-12360" data-mp="38r1ujcbh8uu5">
                {section.books.map(book => <div key={book.id} className="group relative" data-id="element-12361" data-mp="3caioqa033p4v">
                    <div className="aspect-[2/3] w-full overflow-hidden rounded-lg bg-gray-200 shadow-md group-hover:shadow-xl transition-all duration-300" data-id="element-12362" data-mp="3c8z82iainc2k">
                      <img src={book.cover} alt={book.title} className="h-full w-full object-cover object-center group-hover:scale-105 transition-transform duration-300" data-id="element-12363" data-mp="32cw9fmevhvkd" />
                      <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-40 transition-opacity duration-300 flex items-center justify-center opacity-0 group-hover:opacity-100" data-id="element-12364" data-mp="3uh5gw3cgoqc">
                        <div className="flex space-x-2" data-id="element-12365" data-mp="3qa1syrprygbw">
                          <button className="p-2 bg-white rounded-full text-gray-900 hover:text-indigo-600 shadow-lg transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300" data-id="element-12366" data-mp="3q8gyf23gmxe1">
                            <ThumbsUpIcon className="h-5 w-5" data-id="element-12367" data-mp="mm9n5ucyqnir" />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="mt-2" data-id="element-12368" data-mp="2q2560wzh6cq6">
                      <h3 className={`text-sm font-medium ${darkMode ? 'text-gray-200' : 'text-gray-900'}`} data-id="element-12369" data-mp="2q5ase4gpz0i7">
                        <Link to={`/book/${book.id}`} data-id="element-12370" data-mp="2g622pnsw081n">
                          <span aria-hidden="true" className="absolute inset-0" data-id="element-12371" data-mp="3ds9a15gksehp" />
                          {book.title}
                        </Link>
                      </h3>
                      <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`} data-id="element-12372" data-mp="340v3weu4cgfl">
                        {book.author}
                      </p>
                    </div>
                  </div>)}
              </div>
            </section>)}
        </div>
      </div>
    </div>;
};
export default Recommendations;